import { FieldErrors } from './FieldErrors';

import { useFieldContext } from '.';

interface Props {
  label: string;
  required?: boolean;
}

export function GlassCheckbox({ label, required = false }: Props) {
  const field = useFieldContext<boolean>();

  return (
    <div className='relative flex items-start'>
      <div className='flex h-6 items-center'>
        <input
          required={required}
          onChange={(e) => field.handleChange(e.target.checked)}
          checked={field.state.value}
          id={field.name}
          name={field.name}
          type='checkbox'
          onBlur={field.handleBlur}
          className='pop h-5 w-5 cursor-pointer rounded-md border-0 bg-white/85 text-indigo-600 ring ring-white/20 backdrop-blur-sm transition-all duration-300 ease-in-out outline-none focus:shadow-[2px_2px_0px_rgba(0,0,0,1)] checked:bg-indigo-600 checked:ring-indigo-600/20'
        />
      </div>
      <div className='ml-3 leading-6'>
        <label htmlFor={field.name} className='font-medium'>
          {label}
        </label>
      </div>
      <FieldErrors meta={field.state.meta} />
    </div>
  );
}
